import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ApplicationClientCommonModule } from '@sdbn/common';
import { MatTableModule } from '@angular/material/table';
import { RFIDCardProtocolComponent } from './component/rfid-card-protocol.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ApplicationClientCommonModule,
    MatTableModule
  ],
  declarations: [
    RFIDCardProtocolComponent
  ]
})
export class RFIDCardProtocolModule { }

